import React from "react";
import { Link as RouterLink } from "react-router";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link, Stack, Typography } from "@mui/material";

interface BreadcrumbProps {
  items: Array<{
    label: string;
    to?: string;
  }>;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5} mb={3}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <Stack key={index} direction="row" alignItems="center" spacing={0.5}>
            {item.to ? (
              <Link component={RouterLink} to={item.to} variant="body2" color="primary" underline="hover">
                {item.label}
              </Link>
            ) : (
              <Typography variant="body2" color={isLast ? "text.primary" : "text.secondary"}>
                {item.label}
              </Typography>
            )}
            {!isLast && <ChevronRightIcon fontSize="small" color="disabled" />}
          </Stack>
        );
      })}
    </Stack>
  );
};
